// src/components/SEO.jsx
// Reusable component for per-page SEO tags.
// Usage inside any page component:
//   <SEO
//     title="Tadawul Live Candle Chart — SaudiDune"
//     description="Live Saudi Tadawul candle charts with OCR indicator..."
//   />

import React from "react";
import { Helmet } from "react-helmet-async";

export default function SEO({ title, description, image }) {
  const fullTitle = title || "SaudiDune — Marketplace & Trading Tools";
  const desc =
    description ||
    "SaudiDune — cars, real estate, live stock markets, GIS and engineering tools for Saudi Arabia and the region.";
  const img = image || "https://api.saudidune.com/logo192.png";

  return (
    <Helmet>
      <title>{fullTitle}</title>
      <meta name="description" content={desc} />

      {/* Open Graph (Facebook, WhatsApp, LinkedIn) */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={desc} />
      <meta property="og:image" content={img} />

      {/* Twitter card */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={desc} />
      <meta name="twitter:image" content={img} />
    </Helmet>
  );
}
